<template>
  <div class="page-ct">
    <input style="display:none" v-model="changeDetector" />
    <template v-if="!loadingState">
      <div class="page-header">
        <strong>Help Page CMS</strong>
        <div class="top-actions">
          <input type="file" id="file" v-if="withImport" @change="startImport()" />
          <i
            v-if="canWrite"
            title="Import"
            class="action material-icons"
            v-on:click="withImport = !withImport"
            >get_app</i
          >&nbsp;
          <i class="action material-icons" title="Export" v-on:click="onExport()">publish</i>
          <button v-if="canWrite" href="javascript:;" v-on:click="onSettings()">Groups</button>
        </div>
      </div>

      <splitpanes class="default-theme page-content">
        <pane size="30" class="left-pane">
          <div class="list-view mr-0" v-if="pages.length >= 0">
            <div
              v-for="(page, i) in pages"
              :key="i"
              v-on:click="selectGroup(page)"
              v-bind:class="{
                selected: selectedGroup !== null && page.name === selectedGroup.name,
              }"
            >
              {{ page.name }}
            </div>
          </div>
        </pane>
        <pane size="70">
          <p class="page-desc" v-if="!selectedGroup">
            <span>
              Here you can manage Insight Hub help page.
            </span>
          </p>
          <div class="app-detail" v-if="selectedGroup">
            <div class="header-line">
              <div>
                {{ selectedGroup.name }}
              </div>
              <span class="head-action">
                <button v-if="canWrite" href="javascript:;" v-on:click="onUpdate()">Update</button>
              </span>
            </div>
            <!-- form -->
            <div class="app-form-editor">
              <div class="space-between" style="justify-content: start;gap: 20px;padding-top: 4px;">
                <span
                  class="section"
                  v-bind:class="{ 'selected-section': selectedTab === tab.value }"
                  v-for="(tab, i) in tabs"
                  v-bind:key="i"
                  @click="selectTab(tab.value)"
                >
                  {{ tab.name }}
                </span>
              </div>
              <hr style="margin-bottom:0 !important; margin-top: 12px !important;" />

              <!-- Video Section -->
              <div class="section-ct" v-if="selectedTab === 'video'">
                <div class="editor-line form-row">
                  <label>Video URL</label>
                  <input
                    :readonly="!canWrite"
                    type="text"
                    placeholder="https://"
                    v-model="json_content.video.url"
                  />
                  <ToggleButton
                    :disabled="!canWrite"
                    style="margin-left: 20px"
                    :defaultState="json_content.video.is_video_below"
                    v-on:change="triggerEvent"
                    id="video_above"
                    labelEnableText="Below"
                    labelDisableText="Above"
                  />
                </div>
                <div class="editor-line video">
                  <vue-editor :disabled="!canWrite" v-model="json_content.video.content"></vue-editor>
                </div>
              </div>
              <!-- content Section -->
              <div class="section-ct" v-if="selectedTab === 'content'">
                <div class="editor-line">
                  <br />
                  <div v-for="(f, i) in selected_ct.items" :key="i">
                    <div class="accordion active">
                      {{ f.title }}
                      <div class="action-btns wid-145">
                        <div class="move-keys-ct row-direction">
                          <i
                            v-if="canWrite && i !== 0"
                            class="action material-icons keyup m-0"
                            title="Move Up"
                            @click="onMoveRow('up', i, 'items')"
                            >arrow_drop_up</i
                          >
                          <i
                            v-if="canWrite && i < selected_ct.items.length - 1"
                            @click="onMoveRow('down', i, 'items')"
                            class="action material-icons keydown"
                            title="Move Down"
                            >arrow_drop_down</i
                          >
                        </div>
                        <i v-if="canWrite" class="material-icons" v-on:click="editRow(i)">edit</i>
                        <i v-if="canWrite" class="material-icons" v-on:click="selected_ct.items.splice(i, 1)"
                          >delete</i
                        >
                      </div>
                    </div>
                    <div class="panel" style="display:block">
                      <p v-html="f.description"></p>
                    </div>
                  </div>
                  <div class="add-content-btn">
                    <button v-if="canWrite" @click="editRow()">
                      Add Row
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </pane>
      </splitpanes>
    </template>
    <template v-else>
      <div class="loading-spinner-ct">
        <div class="loading-spinner"></div>
        <span>{{ loadingMsg }}</span>
      </div>
    </template>
    <!-- SnackBar + Confirm Dialog -->
    <div id="snackbar">{{ snackBarText }}</div>
    <ConfirmDialog ref="confirmDialogue"></ConfirmDialog>
    <TextEditorDialog ref="textEditorDialog"></TextEditorDialog>
  </div>
</template>
<script>
import AdminPermissionsService from '@/services/admin-permissions.service'
import HttpService from '@/services/http.service'
import { VueEditor } from 'vue2-editor'
import ConfirmDialog from '@/components/dialogs/components/ConfirmDialog.vue'
import TextEditorDialog from '@/components/dialogs/components/TextEditorDialog.vue'
import ToggleButton from '@/components/ToggleButton.vue'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: 'AdminAbout',
  components: {
    VueEditor,
    ConfirmDialog,
    TextEditorDialog,
    ToggleButton,
    Splitpanes,
    Pane,
  },
  data: function() {
    return {
      withImport: false,
      selectedGroup: null,
      pages: [],
      snackBarText: '',
      loadingState: false,
      tabs: [],
      selectedTab: '',
      loadingMsg: '',
      changeDetector: '',
      json_content: {},
      selected_ct: [],
    }
  },
  watch: {
    selectedGroup: {
      immediate: false,
      handler(val) {
        this.selected_ct = this.json_content.sections.filter((s) => s.key === val.key)[0] || null
      },
    },
  },
  computed: {
    canWrite() {
      const aps = new AdminPermissionsService()
      return aps.canWrite('about')
    },
  },
  mounted: async function() {
    this.selectedTab = 'content'
    this.tabs = [
      {
        name: 'Content',
        value: 'content',
      },
      {
        name: 'Video Section',
        value: 'video',
      },
    ]
    this.loadingState = true
    this.loadingMsg = 'Loading Data'
    this.loadGroups()
  },
  methods: {
    onMoveRow(direction, index, field) {
      let switchIndex = index - 1
      if (direction === 'down') {
        switchIndex = index + 1
      }
      let aux = this.selected_ct[field][switchIndex]
      this.selected_ct[field][switchIndex] = this.selected_ct[field][index]
      this.selected_ct[field][index] = aux
      this.changeDetector = ' '
      this.changeDetector = ''
    },
    triggerEvent(value) {
      this.json_content.video.is_video_below = value
    },
    selectTab(section) {
      this.selectedTab = section
    },
    async editRow(i = null) {
      let obj = {
        title: '',
        description: '',
      }
      if (i || i === 0) {
        obj = this.selected_ct.items[i]
      }
      const res = await this.$refs.textEditorDialog.show({
        key: obj.title,
        keyLabel: 'Title',
        value: obj.description,
        valueLabel: 'Content',
      })
      if (res) {
        if (!i && i !== 0) {
          this.selected_ct.items.push({
            title: res.key,
            description: res.value,
          })
        } else {
          this.selected_ct.items[i].title = res.key
          this.selected_ct.items[i].description = res.value
        }
      }
    },
    async loadGroups() {
      const url = `/admin/cms/get/help-page`
      const data = await HttpService.get(url)
      this.pages = data.groups.value
      this.json_content = data.content
      this.loadingState = false
    },
    openSnackbar(text) {
      setTimeout(() => {
        this.snackBarText = text
        let x = document.getElementById('snackbar')
        x.className = 'open'
        setTimeout(() => {
          x.className = x.className.replace('open', '')
        }, 3000)
      }, 300)
    },
    selectGroup(page) {
      this.selectedGroup = page
    },
    onSettings() {
      this.$router.push({ path: '/admin/settings' })
    },
    async onUpdate() {
      const url = `/admin/cms/save/help-page`
      this.loadingState = true
      this.loadingMsg = 'Saving data into database'
      const data = await HttpService.post(url, { content: this.json_content })
      this.loadingState = false
      if (data !== 'fine') {
        return alert(data)
      }
      this.openSnackbar('Data saved!')
      // await this.loadGroups()
    },
    async startImport() {
      const url = `/admin/cms/import/help-page`
      var formData = new FormData()
      var imagefile = document.querySelector('#file')
      formData.append('files', imagefile.files[0])
      this.loadingState = true
      this.loadingMsg = 'Importing data...'
      const data = await HttpService.upload(url, formData, {
        'Content-Type': 'multipart/form-data',
      })
      this.loadingState = false
      if (data !== 'fine') {
        alert(data)
      } else {
        this.loadGroups()
        this.withImport = false
      }
    },
    async onExport() {
      const url = `/admin/cms/export/help-page`
      const name = 'IH_HelpPage.json'
      this.loadingState = true
      this.loadingMsg = 'Exporting...'
      HttpService.download(url).then((r) => {
        this.loadingState = false
        const url = window.URL.createObjectURL(new Blob([r.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
  },
}
</script>
<style scoped src="../../../../assets/css/admin-section.css"></style>
<style scoped>
.row-direction {
  flex-direction: row !important;
  width: 80px !important;
  justify-content: flex-end;
}
.m-0 {
  margin-bottom: 0px !important;
}
.action-column {
  width: 60px;
}
.action-btns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 60px;
  cursor: pointer;
}
.wid-100 {
  width: 100px !important;
}
.wid-145 {
  width: 145px !important;
}
.first-row {
  width: 22%;
  padding-left: 10px;
}
th {
  border: 1px solid #ddd !important;
  padding: 10px !important;
}
td {
  border: 1px solid #ddd !important;
  padding: 10px !important;
}
.add-content-btn {
  display: flex;
  justify-content: center;
}
table {
  width: 100% !important;
  box-shadow: 2px 3px 10px #ddd;
}
.app-form-editor {
  padding-top: 10px;
}
.space-between {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 19px 32px 0px 18px;
}
.section-ct {
  height: calc(100vh - 460px);
  overflow: auto;
}
.section {
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}
.selected-section {
  border-bottom: 4px solid #70c1f0;
}
.video .vueditor,
.intro .vueditor {
  height: 400px !important;
}
.list-view {
  width: 100%;
  height: 100%;
}
.accordion {
  background-color: #f1f1f1;
  color: #141414 !important;
  cursor: auto;
  width: 100%;
  border: none;
  text-align: left;
  outline: none;
  transition: 0.4s;
  margin: 0;
  font-size: 16px;
  font-weight: 700 !important;
  text-transform: none;
  padding: 14px;
  display: flex;
  justify-content: space-between;
  line-height: 20px;
  border-radius: 0;
  min-height: 50px;
  margin-bottom: 4px;
  white-space: normal;
  height: fit-content;
}

.panel {
  padding: 12px 0;
  display: block;
  background-color: #fff;
  overflow: hidden;
  padding-top: 11px;
  border: 1px solid #f1f1f1;
  margin-bottom: 12px;
  border-top: 0;
  margin-top: -4px;
}
.panel p {
  padding: 8px 18px;
}
</style>
